import { Dispatch, ThunkAction } from '../../../../types/actions';
import { IGetState, TBoardId } from '../../../../types/types';
import { getSelectedCards } from '../selectors/getSelectedCards';
import { root } from '../../../../store/constants';
import { getActiveCardId } from '../../../../store/router/selectors/getActiveCardId';
import { getPanelTab } from '../../../../store/router/selectors/getPanelTab';
import { getBoardUserRecentCards } from '../../../../store/model/board/selectors/getBoardUserRecentCards';
import { boardSetUserRecentCards } from '../../../../rest/effects/board/boardSetUserRecentCards';
import { getIsCardMultiselect } from '../selectors/getIsCardMultiselect';
import { getCard } from '../../../../store/model/selectors/getCard';
import { TStatus } from '../../../../types/model';

export const changeCardRoute = (
    boardId: TBoardId,
    trigger: boolean = true,
): ThunkAction => {
    const action = (
        dispatch: Dispatch,
        getState: IGetState
    ) => {
        const state = getState();
        const selectedCards = getSelectedCards(state, boardId);
        const isMultiselect = getIsCardMultiselect(state, boardId);
        let route = '';
        if (!selectedCards || !selectedCards.length) {
            // ничего не делать
        } else if (isMultiselect || selectedCards.length > 1) {
            route = 'cs-' + selectedCards.join('-');
        } else if (selectedCards.length === 1) {
            route = 'c-' + selectedCards[0];
            const activeCardId = getActiveCardId(state);
            if (activeCardId) {
                const tab = getPanelTab(state);
                if (tab) route += '/' + tab;
            }
            const card = getCard(state, selectedCards[0]);
            if (card.status === TStatus.STATUS_ACTIVE) {
                boardSetUserRecentCards(boardId, [...new Set([selectedCards[0], ...getBoardUserRecentCards(boardId)])]);
            }
        }
        root.App.router.navigate(root.App.router.getUrl(route), { trigger });
    };
    return action;
};
